import { createFileRoute } from '@tanstack/react-router'
import { ApiDocsPage } from '../components/pages'
import { staticRouteHead } from '../lib/seo'

export const Route = createFileRoute('/de/api-docs')({
  head: () => staticRouteHead('apiDocs', 'de'),
  component: ApiDocsPage,
})
